import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';
import React from 'react';
import { colors } from '../../constants.js/colors';

const ConfirmableButton = ({
    onClick,
    confirmMessage,
    children,
    confirmButtonText,
    cancelButtonText,
    ...props
}) => {
    const [open, setOpen] = React.useState(false);

    const handleButtonClick = (e) => {
        setOpen(true);
    };

    const handleConfirm = (e) => {
        setOpen(false);
        onClick(e);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <>
            <Button onClick={handleButtonClick} {...props}>
                {children}
            </Button>
            <Dialog open={open} onClose={handleCancel}>
                <DialogTitle>
                    <strong>Confirmación</strong>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>{confirmMessage}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="secondary" variant="outlined">
                        {cancelButtonText}
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        variant="contained"
                        style={{
                            marginRight: 8,
                            background: colors.error.main,
                            color: colors.white,
                        }}
                    >
                        {confirmButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ConfirmableButton;
